export const wait = (ms: number): Promise<void> =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

export const waitMinDuration = async (startedAt: number, minMs: number): Promise<void> => {
  const elapsed = Date.now() - startedAt;
  if (elapsed < minMs) {
    await wait(minMs - elapsed);
  }
};

export const withMinimumDelay = async <T>(promise: Promise<T>, minMs: number): Promise<T> => {
  const startedAt = Date.now();
  try {
    return await promise;
  } finally {
    await waitMinDuration(startedAt, minMs);
  }
};
